module.exports = __webpack_public_path__ + "img/Weapon_28.0a2a9106.png";